<template>
  <v-autocomplete
    :loading="isLoading"
    :items="items"
    :search-input.sync="search"
    flat
    label="Customer"
    clearable
    item-text="email"
    item-value="id"
    no-filter
    v-model="model"
    :disabled="disabled"
    :rules="rules"
  >
    <template v-slot:item="{ item }">
      <v-list-item-avatar
        color="indigo"
        class="headline font-weight-light white--text"
      >{{ item.displayName.charAt(0) }}</v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="item.displayName"></v-list-item-title>
        <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon>mdi-coin</v-icon>
      </v-list-item-action>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Search for a
          <strong>Customer</strong>
        </v-list-item-title>
      </v-list-item>
    </template>
    <template #append-item>
      <v-list-item>
        <v-list-item-title>
          <v-btn @click="newCustomer = !newCustomer">
            Add new customer
          </v-btn>
          <CustomerForm
              :open="newCustomer"
              v-on:add="newCustomer=!newCustomer;fetchClients()"
          />
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from "lodash";
import CustomerForm from "@components/client/CustomerForm.vue";
export default {
  components: {CustomerForm},
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      searchFilters: this.filters,
      items: [],
      newCustomer: false
    };
  },
  props: {
    endpoint:{
      type:String,
      default:"clients/index"
    },
    value: {
      type: Number
    },
    disabled: {
      type: Boolean
    },
    filters: {
      type: Object
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  computed:{
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  watch: {
    search: {
      handler: _.debounce(function() {
        this.fetchClients();
      }, 400)
    },
    filters() {
      if (this.filters) {
        this.searchFilters = this.filters;
        this.getProducts();
      }
    },
  },
  mounted: function() {
    this.fetchClients();
  },
  methods: {
    fetchClients() {
      this.isLoading = true;
      this.$store
        .dispatch(this.endpoint, {
          filters: this.searchFilters,
          search: this.search ?? this.value,
          pagination: {
            rowsPerPage: 30
          }
        })
        .then(({clients}) => {
          this.items = clients.data;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
